// extracted by mini-css-extract-plugin
export default {"wrapper":"Consorcio_wrapper__ZCjEl","wrapperMissao":"Consorcio_wrapperMissao__Rbaho","link":"Consorcio_link__UvBWO"};